(ns teamoesterreich.admin-mode.questionnaire.questionnaire-sort-table
  (:require ["react-virtualized" :as rv]
            [clojure.string]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.data.questionnaire :as d-questionnaire]
            [reagent.core :as r]
            [teamoesterreich.util.log :as log]
            [reagent-material-ui.icons.edit :refer [edit]]
            [reagent-material-ui.icons.check :refer [check]]
            [reagent-material-ui.icons.refresh :refer [refresh]]
            [teamoesterreich.admin-mode.modal.create-with-name-modal :as create-with-name-modal]
            [teamoesterreich.admin-mode.component.ws-event-sync-component :as ws-event-sync-component]
            [reagent-material-ui.icons.add :refer [add]]))







(defn date-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)
        ;l-date (date-h/parse-local-date cell-data)
        ]
    ;(js/console.log l-date)
    (r/as-element
      [:span (if (> (count cell-data) 10)
               (str (subs cell-data 6 8) "." (subs cell-data 4 6) "." (subs cell-data 0 4))
               "-")])))

(defn check-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    (r/as-element
      [:span {:name cell-data} (when cell-data [check])])))

(defn status-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    (r/as-element
      [:span (if cell-data "Aktiv" "Nicht aktiv")])))

(defn edit-cell-renderer [!st]
  (fn [js-parm]
    (let [{cell-data "cellData"} (js->clj js-parm)]
      (r/as-element
        [mui/icon-button {:label   "bearbeiten"
                          :onClick #(swap! vstate/app-state assoc
                                           :edit-questionnaire {:selected-questionnaire (get-in @!st [:data cell-data])}
                                           :questionnaire-detail-loaded false
                                           :selected-questionnaire-loaded true
                                           :site :questionnaire-form
                                           )
                          } [edit {:fontSize "small"}]]))))



(defn inside-table [!st rows]

  (fn [m]
    (let [width (aget m "width")
          height (aget m "height")
          !sort (r/cursor !st [:sort])
          !reverse (r/cursor !st [:reverse])
          !show-inactive (r/cursor !st [:show-inactive])
          ]
      (r/as-element
        [:> rv/Table
         {:headerHeight    50
          :height          (- height 250)
          :rowCount        (count rows)
          :rowGetter       (fn [i]
                             (clj->js (nth rows (aget i "index"))))
          :rowClassName    (fn [i] (when (odd? (aget i "index")) "table-odd"))
          :sort            (fn [s] (swap! !st assoc :sort (aget s "sortBy") :reverse (= "DESC" (aget s "sortDirection"))))
          :sortBy          @!sort
          :sortDirection   (if @!reverse "DESC" "ASC")
          :rowHeight       45
          :width           width
          :headerClassName "headerColumn"
          :className       "QuestionnaireList"}
         (log/debug "rerender " m " @!show-inactive " @!show-inactive " @!sort " @!sort " @!reverse " @!reverse rows)

         [:> rv/Column
          {:label        "Status"
           :dataKey      (name :questionnaireQuestionnaire-published)
           :className    "bordered exampleColumn"
           :style        #js {:overflow "hidden" :textAlign "left"}
           :cellRenderer status-renderer
           :width        100}]
         [:> rv/Column
          {:label     "Fragebogen Name"
           :dataKey   (name :questionnaireQuestionnaire-name)
           :className "bordered exampleColumn"
           :style     #js {:overflow "hidden" :textAlign "left"}
           :width     270}]
         [:> rv/Column
          {:label        "Persönlich"
           :dataKey      (name :questionnaireQuestionnaire-appearenceSelf)
           :className    "bordered exampleColumn"
           :style        #js {:overflow "hidden" :textAlign "center"}
           :cellRenderer check-renderer
           :width        170}]
         [:> rv/Column
          {:label        "Standort"
           :dataKey      (name :questionnaireQuestionnaire-appearenceLocation)
           :className    "bordered exampleColumn"
           :style        #js {:overflow "hidden" :textAlign "center"}
           :cellRenderer check-renderer
           :width        170}]
         [:> rv/Column
          {:label        "Start"
           :dataKey      (name :questionnaireQuestionnaire-timeFrom)
           :className    "bordered exampleColumn"
           :style        #js {:overflow "hidden" :textAlign "left"}
           :cellRenderer date-renderer
           :width        120}]
         [:> rv/Column
          {:label     "Fragen"
           :dataKey   (name :_questionnaireQuestionnaire-questionCount)
           :className "bordered exampleColumn"
           :style     #js {:overflow "hidden" :textAlign "left"}
           :width     120}]
         [:> rv/Column
          {:label        "#"
           :dataKey      (name :questionnaireQuestionnaire-uuid)
           :className    "bordered exampleColumn"
           :cellRenderer (edit-cell-renderer !st)
           :width        70}]

         ]))))


(defn filter-fn [rows show-inactive search sort_ reverse_]
  (log/debug "filter-fn " (clj->js rows) " sort " (clj->js sort_)  " show-inactive "  (clj->js show-inactive))
  (let [rows (if rows (map (fn [[k v]] [k (assoc v :index k)]) rows) {})
        rows (filter (fn [[k e]]
                       (and
                         true
                         (or show-inactive
                             (and (:questionnaireQuestionnaire-active e)))
                         (re-find
                           (re-pattern (reduce (fn [c e] (str c "(?=.*" e ")")) "(?i)^" (clojure.string/split search " ")))
                           (str (:questionnaireQuestionnaire-uuid e) "#" (:questionnaireQuestionnaire-name e)))
                         ))
                     rows)
        rows (if sort_ (sort-by (fn [[k v]]
                                  ;(log/debug "sort v " sort_ (get v (keyword sort_)))
                                  (get v (keyword sort_))) rows) rows)
        rows (if reverse_ (reverse rows) rows)]
    rows
    ))

(defn update-list [!st !show-inactive]


  (let [!search (r/cursor !st [:search])
        !sort (r/cursor !st [:sort])
        !reverse (r/cursor !st [:reverse])]

    (log/debug "update-list " @!sort)

    (if-not (:loaded @!st)
      (d-questionnaire/get-questionnaire-list
        (fn [data]
          (let [r-data (filter-fn data @!show-inactive (str @!search) @!sort @!reverse)]
            (swap! !st assoc
                   :data data
                   :loaded true
                   :count (count r-data)
                   :rows (mapv (fn [[k v]] v) r-data))))
        )
      (let [r-data (filter-fn (:data @!st) @!show-inactive (str @!search) @!sort @!reverse)]
        (swap! !st assoc
               :count (count r-data)
               :rows (mapv (fn [[k v]] v) r-data)))
      )))



(defn get-table [!st !rows]
  (fn [] [:> rv/AutoSizer
          {:style {:height "100%" :minHeight "600px"}
           :sort  (str "rerender !st" @!st)}
          (inside-table !st @!rows)]))


(defn get-it []

  (let [!st (r/cursor vstate/app-state [:questionnaire :questionnaire-list-state])
        !create-modal (r/cursor !st [:create-modal])
        !show-inactive (r/cursor !st [:show-inactive])
        !loaded? (r/cursor !st [:loaded])
        !rows (r/cursor !st [:rows])
        ]
    (js/console.log "Mount toe-questionnaire " (clj->js @!rows))

    (update-list !st !show-inactive)

    [mui/paper
     [create-with-name-modal/modal
      !create-modal
      "Bitte gib einen Namen für den neuen Fragebogen ein"
      "Erstellen"
      (fn [name]
        (log/debug "Create questionnaire with Name: " name)
        (d-questionnaire/>new-questionnaire name (fn [new]
                                                   (log/debug "Created questionnaire : " new (get new :questionnaireQuestionnaire-uuid))
                                                   (reset! !loaded? false)
                                                   (reset! !show-inactive val)
                                                   (update-list !st !show-inactive)
                                                   ))
        )
      ]
     [mui/grid
      {:container  true
       :direction  "row"
       :alignItems "stretch"
       :justify    "flex-start"
       :spacing    1
       :style      {:margin "15px 0 0 0"}
       }

      [mui/grid
       {:item true
        :lg   2
        :md   3
        :xs   6
        }
       [mui/button {:startIcon (r/as-element [add]) :color "secondary" :variant "outlined" :style {:margin "5px 40px 5px 0"}
                    :onClick   #(reset! !create-modal true)
                    }
        "Neuer Fragebogen"]
       ]
      [mui/grid
       {:item true
        :lg   7
        :md   5
        :xs   6
        :type {:textAlign "bottom"}
        }
       [mui/typography {:variant "h5" :padding "5px 0 0 0"
                        :onClick #(reset! !loaded? false)
                        } " Fragebogen Liste "]
       ]
      [mui/grid
       {:item true
        :lg   2
        :md   2
        :xs   4
        }
       [mui/radio-group {:row true :class "filterRadio"}

        [mui/form-control-label {:label   "Nicht aktive einblenden" :value "dst" :placement "start"
                                 :control (r/as-element [mui/checkbox {:checked  (or @!show-inactive false)
                                                                       :onChange (fn [_ val]
                                                                                   (reset! !show-inactive val)
                                                                                   (update-list !st !show-inactive)
                                                                                   )
                                                                       }])}]

        ]

       ]

      [mui/grid
       {:item  true
        :lg    1
        :md    1
        :xs    2
        :style {:height "50px"}
        }
       [ws-event-sync-component/ws-event-reload !loaded? :questionnaire-questionnaire]]


      [mui/grid
       {:item true
        :xs   12
        }
       ;(js/console.log "########## get-table " @!rows)
       [get-table !st !rows]
       ]
      ]

     ]))
